
import AppMissingModule from "@/components/common/MissingModule.vue";
import AppExtraFieldsInfo from "@/components/ExtraFieldsInfo.vue";
import { Product } from "@/models/base";
import { AuthService } from "@/services/auth-service";
import Vue from "vue";
import { ExtraFieldNamesConfig } from "../../models/dossier-configs/extra-field-names-config";
import { DossierConfigService } from "../../services/dossier-config-service";
import AppImages from "./ProductInfoImages.vue";
import AppLabel from "@/components/common/InfoInput.vue";
import AppProductInfoAccounting from "./ProductInfoAccounting.vue";
import AppProductInfoAwsDocuments from "./ProductInfoAwsDocuments.vue";

export default Vue.extend({
	props: {
		product: Object as () => Product
	},
	computed: {
		extraFieldNameSettings(): ExtraFieldNamesConfig {
			return DossierConfigService.getExtraFieldNamesConfigs().ProductNames;
		}
	},
	methods: {
		isAllowed(value: number): Boolean {
			return AuthService.hasModule(value);
		}
	},
	components: {
		AppImages,
		AppExtraFieldsInfo,
		AppMissingModule,
		AppLabel,
		AppProductInfoAccounting,
		AppProductInfoAwsDocuments
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
